import { ModalShell } from "./ModalShell";
import { OutOfIterationsMessage } from "./OutOfIterations";

/**
 * Dismissible version of the out-of-iterations message, for the gallery.
 *
 * The gallery stays fully usable without a subscription, so this interrupts
 * only the one action that would need an iteration — "Resume from Here" —
 * and lets the user return to browsing.
 */
export function OutOfIterationsModal({ onClose }: { onClose: () => void }) {
  return (
    <ModalShell
      onClose={onClose}
      ariaContext="out of visualizations"
      labelledBy="out-of-iterations-modal-title"
      cardClassName="relative flex w-full max-w-[480px] flex-col items-center rounded-2xl bg-[var(--bg-modal)] px-8 py-10 shadow-xl"
    >
      <OutOfIterationsMessage titleId="out-of-iterations-modal-title" />
    </ModalShell>
  );
}
